import { Media } from "../../../core/database/db";

/**
 * Returns a copy of `list` with `items` inserted at `index`. Appends when `index` is omitted or
 * out of range, so callers can pass a `findIndex` result straight through.
 */
export function insertAt<T>(list: readonly T[], items: readonly T[], index?: number): T[] {
  if (index === undefined || index < 0 || index > list.length) {
    return [...list, ...items];
  }
  return [...list.slice(0, index), ...items, ...list.slice(index)];
}

/**
 * Orders photos held as saved records plus staged additions: saved ones by id, then staged
 * ones in the order they were added. A staged copy listed in `anchors` (fileIdentifier ->
 * id of the saved photo it replaced, e.g. an annotated copy) takes that photo's slot instead.
 */
export function orderSavedAndStagedMedia(
  saved: readonly Media[],
  staged: readonly Media[],
  anchors: ReadonlyMap<string, number> = new Map()
): Media[] {
  const anchored = staged
    .filter(media => anchors.has(media.fileIdentifier))
    .map(media => ({ media, key: anchors.get(media.fileIdentifier)! }));
  const ordered = [...saved.map(media => ({ media, key: Number(media.id) })), ...anchored]
    .sort((a, b) => a.key - b.key)
    .map(entry => entry.media);

  return [...ordered, ...staged.filter(media => anchors.has(media.fileIdentifier) === false)];
}
